var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-sheet',{attrs:{"height":"100%","width":"750px"}},[(_vm.tab === 0)?_c('table-scroll',{attrs:{"payment":_vm.payment}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }